import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import faker from "faker";
import { Box, Paper, Skeleton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { IRIS_60, WHITE } from "../../colors";
import { DateTime } from "luxon";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export const options = {
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: true,
      text: "New Applications- Last 12 months",
    },
  },
  scales: {
    y: {
      type: "linear",
      display: true,
      position: "left",
      min: 0,
      max: 100,
      ticks: {
        // stepSize: 10,
        // count: 1,
        stepSize: 1,
      },
    },
    // y1: {
    //   type: "linear",
    //   display: true,
    //   position: "right",
    //   grid: {
    //     drawOnChartArea: false,
    //   },
    // },
  },
};

const CustomPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  paddingTop: 15,
  paddingBottom: 10,
  paddingLeft: 15,
  height: 400,
  paddingRight: 15,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  borderRadius: 10,
  minWidth: 570,
}));

const labels = ["January", "February", "March", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];

const getMonth = (date) => {
  const weekday = ["January", "February", "March", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const d = new Date(date);
  return weekday[d.getMonth()];
};

export default function Graph(props) {
  const lenOnMonth = (customers, day) => {
    var res = [];
    customers?.forEach((c) => {
      let date1 = new Date(c.createdAt);
      const yearMonth1 = `${date1.getFullYear()}-${date1.getMonth()}`;
      let date2 = new Date(day);
      const yearMont2 = `${date2.getFullYear()}-${date2.getMonth()}`;

      if (yearMonth1 === yearMont2) {
        res.push(c);
      }
    });
    return res.length;
  };

  const months = [
    {
      label: getMonth(DateTime.now().minus({ months: 11 }).toString()),
      data: lenOnMonth(props.people, DateTime.now().minus({ months: 11 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getMonth(DateTime.now().minus({ months: 10 }).toString()),
      data: lenOnMonth(props.people, DateTime.now().minus({ months: 10 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getMonth(DateTime.now().minus({ months: 9 }).toString()),
      data: lenOnMonth(props.people, DateTime.now().minus({ months: 9 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getMonth(DateTime.now().minus({ months: 8 }).toString()),
      data: lenOnMonth(props.people, DateTime.now().minus({ months: 8 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getMonth(DateTime.now().minus({ months: 7 }).toString()),
      data: lenOnMonth(props.people, DateTime.now().minus({ months: 7 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getMonth(DateTime.now().minus({ months: 6 }).toString()),
      data: lenOnMonth(props.people, DateTime.now().minus({ months: 6 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getMonth(DateTime.now().minus({ months: 5 }).toString()),
      data: lenOnMonth(props.people, DateTime.now().minus({ months: 5 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getMonth(DateTime.now().minus({ months: 4 }).toString()),
      data: lenOnMonth(props.people, DateTime.now().minus({ months: 4 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getMonth(DateTime.now().minus({ months: 3 }).toString()),
      data: lenOnMonth(props.people, DateTime.now().minus({ months: 3 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getMonth(DateTime.now().minus({ months: 2 }).toString()),
      data: lenOnMonth(props.people, DateTime.now().minus({ months: 2 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getMonth(DateTime.now().minus({ months: 1 }).toString()),
      data: lenOnMonth(props.people, DateTime.now().minus({ months: 1 }).toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: getMonth(DateTime.now().toString()),
      data: lenOnMonth(props.people, DateTime.now().toString()),
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
  ];

  const data = {
    labels: months?.map((d) => d.label),
    datasets: [
      {
        label: "Number of new applications",
        data: months?.map((d) => d.data),
        backgroundColor: "#59A7FF",
      },
    ],
  };
  return (
    <CustomPaper>
      {/* <Typography fontSize={18} color={IRIS_60} style={{ marginLeft: 25 }}>
        
      </Typography> */}
      {props.people && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Line options={options} data={data} width={430} height={330} />
        </Box>
      )}
      {!props.people && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Skeleton variant="rectangular" width={430} height={330} />
        </Box>
      )}
    </CustomPaper>
  );
}
